<div class="px-5 pb-5">
  <h1 class="cbb-page-title mb-4">Ventas Cemento</h1>
  <app-ventas-cemento-tabla></app-ventas-cemento-tabla>
</div>
